<template>
  <div>
    <div class="fill">
      <custom-form
        :getCustomFormUrl="getCustomFormUrl"
        :getCustomFormParams="getCustomFormParams"
        @submitEvent="submitForm"
        :disabled="disabled"
        @form-empty="submitForm([])"
      >
        <template v-slot:privacyAgreement>
          <privacy-agreement @checked="handleChecked"/>
        </template>
      </custom-form>
    </div>
    <footer-logo></footer-logo>
  </div>
</template>
<script>
import footerLogo from '@/components/footerLogo.vue'
import customform from '@/components/customform.vue'
import PrivacyAgreement from "@/components/privacyAgreement";

export default {
  data() {
    return {
      disabled: false,
      tickePrice: this.$route.query.tickePrice,
      getCustomFormUrl: '/api/Activity/GetCustomForm',
      getCustomFormParams: {
        ticketId: this.$route.query.ticketId,
        buyCount: this.$route.query.buyCount,
        activityId: this.$route.query.activityId
      },
      isChecked: false
    }
  },
  created() {
  },
  methods: {
    submitForm(formData) {
      if(!this.isChecked){
        this.$dialog.toast({
          mes: "请勾选同意《法律声明及隐私权政策》后再提交申请",
          timeout: 2500
        })
        return;
      }

      let signupFormData = {
        formValuesString: JSON.stringify(this.convertFormData(formData)),
        FormElementsList: formData,
        Email: this.$route.query.Email,
        RealName: this.$route.query.RealName,
        MobileTelephone: this.$route.query.MobileTelephone,
        ticketId: this.$route.query.ticketId,
        buyCount: this.$route.query.buyCount,
        activityId: this.$route.query.activityId
      }

      this.disabled = true

      this.$delay(300).then(() => {
        this.$post('/api/Activity/SignupTicket', signupFormData)
          .then(result => {
            this.disabled = false
            this.$router.push({
              name: 'activity-signup-success'
            })
          })
          .catch(result => {
            this.$dialog.toast({
              mes: result.Error.Message,
              timeout: 2500
            })
            this.disabled = false
          })
      })
    },
    convertFormData(formData) {
      var result = []
      if (formData && formData.length) {
        formData.forEach(element => {
          let item = {
            formElementId: element.ID,
            InputValue: null
          }
          if (element.InputValue) {
            item.InputValue = element.InputValue
          } else if (element && element.OptionArray && element.OptionArray.length) {
            item.InputValue = element.OptionArray.join(',')
          }
          result.push(item)
        })
      }
      return result
    },
    handleChecked(checked) {
      this.isChecked = checked;
    }
  },
  components: {
    PrivacyAgreement,
    'custom-form': customform,
    'footer-logo': footerLogo
  }
}
</script>
<style lang='less' scoped="">
.fill {
  width: 100%;
  // padding-bottom: 2.5rem;
  position: relative;
  z-index: 1;
}
</style>
